import { Injectable } from "@angular/core";

interface PdfView {
  previewFile: (options: any, mode: any) => void;
}

@Injectable()
export class PdfService {
  attachPdfUrlToElement(
    element: HTMLElement,
    locationUrl: string,
    fileName: string
  ): void {}

  attachPdfPromiseToElement(
    element: HTMLElement,
    promise: Promise<Blob>,
    fileName: string
  ): void {}
}
